










import Component from 'vue-class-component';
import Vue from 'vue';
import DataLoggerAutocomplete
  from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import { VModel } from 'vue-property-decorator';
import { required } from '@/common/validation/validation';
import TextField from '@/general/component/TextField.vue';
import { AssignWorkPeriod } from '@/context/work_period/model/AssignWorkPeriod';
import LocationAutocomplete from '@/general/component/form/autocomplete/LocationAutocomplete.vue';
import WorkPeriodTemplateAutocomplete
  from '@/general/component/form/autocomplete/WorkPeriodTemplateAutocomplete.vue';

@Component({
  components: {
    DataLoggerAutocomplete,
    WorkPeriodTemplateAutocomplete,
    LocationAutocomplete,
    FacilityAutocomplete,
    TextInput,
    TextField
  }
})
export default class AssignWorkPeriodFormTemplate extends Vue {
  @VModel({ type: Object }) model!: AssignWorkPeriod;
  valid = true;

  get rules(): Record<string, unknown> {
    return {
      facility: [required],
      identifier: [required]
    };
  }
}
